export default __webpack_public_path__ + "static/media/hero-coding.27e37b9a.jpg";